import createIcon from '../../createIcon';

/**
 * @component @name BookmarkAdd
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgN0gxOFY5SDE2VjdIMTRWNUgxNlYzSDE4VjVIMjBWN1pNMTggMjFMMTEgMThMNCAyMVY1QzQgMy45IDQuOSAzIDYgM0gxM0MxMi4zNyAzLjg0IDEyIDQuODcgMTIgNkMxMiA4Ljc2IDE0LjI0IDExIDE3IDExQzE3LjM0IDExIDE3LjY4IDEwLjk3IDE4IDEwLjlWMjFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BookmarkAdd = createIcon('BookmarkAdd', [
  [
    'path',
    {
      d: 'M20 7H18V9H16V7H14V5H16V3H18V5H20V7ZM18 21L11 18L4 21V5C4 3.9 4.9 3 6 3H13C12.37 3.84 12 4.87 12 6C12 8.76 14.24 11 17 11C17.34 11 17.68 10.97 18 10.9V21Z',
      key: 'ojoc6a',
    },
  ],
]);

export default BookmarkAdd;
